import React from "react";
import {DysonSphere, FactoryGameType, Satisfactory, SpecificFactoryData} from "../../../types";
import {FactoryGameDataSatisfactory} from "./Satisfactory";
import {FactoryGameDataDysonSphere} from "./DysonSphere";

type Props = {
    factoryGameData: SpecificFactoryData,
    setFactoryGameData: (newFactoryGameData: SpecificFactoryData) => void,
    translateDialogue: (key: string) => string,
    gameType: FactoryGameType,
}

export default function FactoryGameDataFactory({ factoryGameData, setFactoryGameData, translateDialogue, gameType }: Props) {
    switch (gameType) {
        case FactoryGameType.Satisfactory:
            return <FactoryGameDataSatisfactory factoryGameData={factoryGameData as SpecificFactoryData<Satisfactory>} setFactoryGameData={setFactoryGameData} translateDialogue={translateDialogue} />
        case FactoryGameType.DysonSphere:
            return <FactoryGameDataDysonSphere factoryGameData={factoryGameData as SpecificFactoryData<DysonSphere>} setFactoryGameData={setFactoryGameData} translateDialogue={translateDialogue} />
    }
}
